<template>
  <div class="of-hidden login-bg">
    <div class="logo"><img class="logo" src="../../assets/logo.png" /></div>
    <el-row class="login-row" type="flex">
      <el-col :span="13" class="login-left">
        <h1 class="an-frist">
          更简单的<span class="text-primary f-40">社交</span>媒体工具
        </h1>
        <h1 class="m-t-15 an-frist">
          实现<span class="text-success">真实参与</span>
        </h1>
        <img src="../../assets/home_bg_01_1.png" />
      </el-col>
      <el-col :span="11" class="login-form">
        <h1>登录</h1>
        <el-form label-position="left" ref="form" :model="form" :rules="rules">
          <el-form-item label="账号" prop="account">
            <el-input
              type="text"
              autocomplete="off"
              placeholder="请输入邮箱"
              v-model="form.account"
            ></el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input
              type="password"
              autocomplete="off"
              placeholder="请输入密码"
              v-model="form.password"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              class="lang"
              @click="submit('form')"
              :loading="loading"
              >{{ loading ? "登录中..." : "登录" }}</el-button
            >
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <div class="footer">©copyright 2023 tools.nothingdb.com</div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { email } from "@/utils/regexp.js";
export default {
  created() {
    window.document.addEventListener("keyup", this.ketBored);
  },
  destroyed() {
    window.document.removeEventListener("keyup", this.ketBored);
  },
  data() {
    var rule_pw = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("密码不得为空！"));
      } else {
        callback();
      }
    };
    var rule_at = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("账号不得为空！"));
      } else {
        if (!email.test(value)) {
          return callback(new Error("请输入正确邮箱"));
        }
        callback();
      }
    };
    return {
      form: {
        account: "",
        password: "",
      },
      rules: {
        account: [{ validator: rule_at, trigger: "blur" }],
        password: [{ validator: rule_pw, trigger: "blur" }],
      },
    };
  },
  // computed:mapState({
  //   loading:(state)=>state.loginUser.loading,
  // }),
  computed: {
    ...mapState("loginUser", ["loading"]),
  },
  methods: {
    submit(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          localStorage.removeItem("userInfo");
          let res = await this.$store.dispatch("loginUser/login", {
            userName: this.form.account,
            passWord: this.form.password,
          });
          if (res) {
            localStorage.setItem("userInfo", res.token);
            this.$router
              .push(this.$route.query.returnUrl || "/home")
              .catch(() => {});
            this.$message({
              showClose: true,
              type: "success",
              message: "登录成功",
            });
          }
        } else {
          return false;
        }
      });
    },
    ketBored(event) {
      if (event.key === "Enter") {
        this.submit("form");
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./login.less";
</style>
